// @ vendors
const React = require('react');
const { PropTypes } = require('prop-types');
const { connect } = require('react-redux');
// @ components
const { LoadingSection } = require('commonsComponents/loadingSection');
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;
// @ constants
const { GDPR_ID } = require('constants/operationTypes');

class GDPRSignaturePatternSimple extends React.Component {
    render() {
        const { operationType, immGDPRConsents, customComponentDidUpdate, printTitleValue } = this.props;

        if (immGDPRConsents.get('isFetching')) {
            return <LoadingSection />;
        } else if (immGDPRConsents.get('fetchSuccess')) {
            if (operationType !== GDPR_ID && immGDPRConsents.get('otp')) {

                return (
                    <SignaturePattern
                        printTitleValue={printTitleValue}
                        operationType={GDPR_ID}
                        operationParams={{}}
                        customComponentDidUpdate={customComponentDidUpdate}
                    />
                );
            } else {
                return (<div></div>);
            }
        } else return (<div></div>);
    }
}

GDPRSignaturePatternSimple.propTypes = {
    // public props
    operationType: PropTypes.number,
    printTitleValue: PropTypes.string,
    operationParams: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ]),
    multiOTPMessageCode: PropTypes.number,
    customComponentDidUpdate: PropTypes.func,
    immGDPRConsents: PropTypes.object.isRequired
};

module.exports.constructor = GDPRSignaturePatternSimple;
module.exports.GDPRSignaturePatternSimple = connect(
    state => ({
        immGDPRConsents: state.gdprConsents
    })
)(GDPRSignaturePatternSimple);
